"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardFormPublicPropsValidator = void 0;
var tslib_1 = require("tslib");
var PaymentProvider_1 = require("@wix/cashier-common/dist/src/enums/payments/PaymentProvider");
var experimentsService_1 = require("@wix/cashier-common/dist/src/utils/experimentsService");
var validateGUID_1 = require("@wix/cashier-common/dist/src/utils/guid/validateGUID");
var React = require("react");
var errorReporter_1 = require("../../utils/errorReporter");
var fedopsLogger_1 = require("../../utils/fedopsLogger");
var isPlainObject_1 = require("../../utils/isPlainObject");
var controller_1 = require("./controller");
var CardFormPublicPropsValidator = /** @class */ (function (_super) {
    tslib_1.__extends(CardFormPublicPropsValidator, _super);
    function CardFormPublicPropsValidator(props) {
        var _this = _super.call(this, props) || this;
        _this.reportCrash = function (errorOrMessage, shouldCapture) {
            if (shouldCapture === void 0) { shouldCapture = true; }
            if (shouldCapture) {
                if (errorOrMessage instanceof Error) {
                    errorReporter_1.captureException(errorOrMessage, false);
                }
                else {
                    errorReporter_1.captureMessage(errorOrMessage);
                }
            }
            if (_this.props.onCrash) {
                try {
                    var message = typeof errorOrMessage === 'string'
                        ? errorOrMessage
                        : errorOrMessage.message;
                    console.error("CardForm: " + message);
                    _this.props.onCrash(message);
                }
                catch (error) {
                    console.error("CardForm: onCrash failed to execute", error);
                }
            }
        };
        _this.validateProps = function () {
            if (_this.props.providerId === PaymentProvider_1.PaymentProvider.TwoCheckout &&
                (!_this.props.sellerId || !_this.props.publishableKey)) {
                return [
                    false,
                    "sellerId & publishableKey props are missing (required for TwoCheckout PP)",
                ];
            }
            if (_this.props.providerId === PaymentProvider_1.PaymentProvider.Square &&
                !_this.props.squareAppId) {
                return [false, "squareAppId prop is missing (required for Square PP)"];
            }
            if (typeof _this.props.visitorId === 'undefined') {
                console.warn("CardForm: missing visitorId prop. Experiments will be conducted without forVisitors context & BI will miss it");
            }
            else if (!validateGUID_1.validateGUID(_this.props.visitorId)) {
                return [
                    false,
                    "passed prop visitorId \"" + _this.props.visitorId + "\" is invalid",
                ];
            }
            if (typeof _this.props.siteOwnerId === 'undefined') {
                console.warn("CardForm: missing siteOwnerId prop. Experiments will be conducted without forVisitors context");
            }
            else if (!validateGUID_1.validateGUID(_this.props.siteOwnerId)) {
                return [
                    false,
                    "passed prop siteOwnerId \"" + _this.props.siteOwnerId + "\" is invalid",
                ];
            }
            var consentPolicyHeader = _this.props.consentPolicyHeader;
            if (!_this.isConsentPolicyHeaderValid()) {
                console.warn("CardForm: prop \"consentPolicyHeader\" is invalid - " + JSON.stringify(consentPolicyHeader) + ". Should be an object with string values");
            }
            return _this.validateOverrides();
        };
        _this.validateOverrides = function () {
            var _a = _this.props, baseURLOverride = _a.baseURLOverride, apiBaseURLOverride = _a.apiBaseURLOverride;
            if (baseURLOverride && new URL(baseURLOverride).hostname !== 'localhost') {
                return [
                    false,
                    "\"baseURLOverride\" hostname other than \"localhost\" is prohibited",
                ];
            }
            if (apiBaseURLOverride) {
                if (new URL(apiBaseURLOverride).hostname !== 'localhost') {
                    return [
                        false,
                        "\"apiBaseURLOverride\" hostname other than \"localhost\" is prohibited",
                    ];
                }
                if (!baseURLOverride) {
                    return [
                        false,
                        "\"apiBaseURLOverride\" is allowed only in pair with \"baseURLOverride\"",
                    ];
                }
            }
            return [true];
        };
        try {
            if (!experimentsService_1.experimentsService.getInstance()) {
                console.error("CardForm: experimentsService is expected to be inited before mount");
            }
            errorReporter_1.initComponentErrorReporter({
                userId: props.visitorId,
                msid: props.msid,
                locale: props.locale,
                country: props.country,
                providerId: props.providerId,
                appId: props.appId,
            });
            fedopsLogger_1.reportLoadStart();
        }
        catch (error) {
            console.error(error);
        }
        try {
            var _a = _this.validateProps(), isPropsValid = _a[0], invalidityReason = _a[1];
            _this.state = {
                shouldRender: isPropsValid,
            };
            if (!isPropsValid) {
                _this.reportCrash(invalidityReason);
            }
        }
        catch (error) {
            _this.reportCrash(error);
        }
        return _this;
    }
    CardFormPublicPropsValidator.prototype.isConsentPolicyHeaderValid = function () {
        var consentPolicyHeader = this.props.consentPolicyHeader;
        return (typeof consentPolicyHeader === 'undefined' ||
            (isPlainObject_1.isPlainObject(consentPolicyHeader) &&
                Object.values(consentPolicyHeader).every(function (value) { return typeof value === 'string'; })));
    };
    Object.defineProperty(CardFormPublicPropsValidator.prototype, "passedProps", {
        get: function () {
            var _a = this.props, consentPolicyHeader = _a.consentPolicyHeader, onCrash = _a.onCrash, restProps = tslib_1.__rest(_a, ["consentPolicyHeader", "onCrash"]);
            return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, restProps), (this.isConsentPolicyHeaderValid() && {
                consentPolicyHeader: consentPolicyHeader,
            })), { reportCrash: this.reportCrash });
        },
        enumerable: false,
        configurable: true
    });
    CardFormPublicPropsValidator.prototype.render = function () {
        if (!this.state.shouldRender) {
            return null;
        }
        return React.createElement(controller_1.CardFormPublicController, tslib_1.__assign({}, this.passedProps));
    };
    return CardFormPublicPropsValidator;
}(React.Component));
exports.CardFormPublicPropsValidator = CardFormPublicPropsValidator;
//# sourceMappingURL=props-validator.js.map